import Vue from 'vue'
import Vuex from 'vuex'
import { authentication } from './auth_module'
import VuexPersist from 'vuex-persist'

const apiUrl = process.env.VUE_APP_API_URL
const vuexLocalStorage = new VuexPersist({
    key: 'vuex', // The key to store the state on in the storage provider.
    storage: window.localStorage, // or window.sessionStorage or localForage
    // Function that passes the state and returns the state with only the objects you want to store.
    // reducer: state => state,
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
    reducer: state => ({
        authentication: state.authentication
        // getRidOfThisModule: state.getRidOfThisModule (No one likes it.)
    })
})

Vue.use(Vuex)

export const store = new Vuex.Store({
    plugins: [vuexLocalStorage.plugin],
    modules: {
        authentication
    },

    state: {
        apiUrl: apiUrl,
        snackbarTimeout: 6000,
        snackbarY: 'bottom',
        snackbarX: 'center',
        snackbarMode: 'multi-line',
        callSnackbar: 0,
        snackbarMessage: '',
        snackbarContext: '',
        snackbarFromRouter: false,

        userUrl: `${apiUrl}/user`,
        companyUrl: `${apiUrl}/company`,
        tagUrl: `${apiUrl}/tag`,
        authUrl: `${apiUrl}/auth`,
        docUrl: `${apiUrl}/doc`,
        docApprovalUrl: `${apiUrl}/docapproval`,
        dashboardUrl: `${apiUrl}/dashboard`,
        companyEmailListUrl: `${apiUrl}/companyemaillist`,
        resetPwRequestUrl: `${apiUrl}/reset-pw/request`,
        resetPwSubmitUrl: `${apiUrl}/reset-pw/submit`
    },
    getters: {
        hasAdmin(state) {
            return state.authentication.loggedInUser.role.includes('Admin')
        }
    },
    mutations: {
        showSnackbar(state, snackbarParams) {
            state.snackbarMessage = snackbarParams.message
            state.snackbarContext = snackbarParams.context
            state.snackbarTimeout = 6000
            state.callSnackbar += 1
            state.snackbarFromRouter = false
        },
        closeSnackbar(state) {
            state.callSnackbar = 0
        },
        setSnackbarFromRouter(state) {
            state.snackbarFromRouter = true
        }
    },

    actions: {}
})
